<div class="mos-u-spacer--margin-bottom-md">
  <atlas-card fullWidth="true" [elevation]="'raised'" [headerPaddingClass]="''" [contentPaddingClass]="''">
    <atlas-card-content class="dsp-mobile-card-content">
      <div class="dsp-mobile-card-header dsp-mobile-card-column mos-u-divider--bottom-md">
        <strong>{{ formatDate(transaction.date, 'DD/MM/YYYY') }}</strong>
        <strong>{{ transaction.description }}</strong>
      </div>
      <span class="dsp-mobile-card-label">
        Amount Currency
      </span>
      <span class="dsp-mobile-card-value dsp-numeric-font">
        ${{ transaction.amount | decimal }}
      </span>
      <div class="dsp-mobile-card-row">
        <div class="dsp-mobile-card-column">
          <span class="dsp-mobile-card-small-label">
            Unit Price*
          </span>
          <strong class="dsp-mobile-card-small-value dsp-numeric-font">
            ${{ transaction.unitPrice | decimal }}
          </strong>
        </div>
        <div class="dsp-mobile-card-column">
          <span class="dsp-mobile-card-small-label">
            Units
          </span>
          <strong class="dsp-mobile-card-small-value dsp-numeric-font">
            {{ transaction.units | decimal }}
          </strong>
        </div>
        <div class="dsp-mobile-card-column">
          <span class="dsp-mobile-card-small-label">
            Unit Balance
          </span>
          <strong class="dsp-mobile-card-small-value dsp-numeric-font">
            {{ transaction.unitBalance | decimal }}
          </strong>
        </div>
      </div>
    </atlas-card-content>
  </atlas-card>
</div>